import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';

import { formatAmount } from '../../../../../../../../common/formatAmount';
import Text from '../../../../../../../../components/_core/Text';
import RevenueTooltip from '../../../RevenueTooltip';
import { locales } from './locales';

interface RevenueRowProps {
  computedRevenue: number;
  vatAmount: number;
  shineRevenue: number;
  complementaryRevenue: number;
  isSubjectToVAT: boolean;
}

const RevenueRow: FC<RevenueRowProps> = ({
  complementaryRevenue,
  computedRevenue,
  isSubjectToVAT,
  shineRevenue,
  vatAmount,
}) => {
  return (
    <HStack justifyContent="space-between" w="full">
      <Text variant="light">{locales.label}</Text>

      <HStack gap="space-8">
        <Text fontWeight="weight-500" variant="light">
          {formatAmount({ forcePlusSign: false, value: computedRevenue })}
        </Text>

        <RevenueTooltip
          complementaryRevenue={complementaryRevenue}
          isSubjectToVAT={isSubjectToVAT}
          shineRevenue={shineRevenue}
          vatAmount={vatAmount}
        >
          <SunshineIcon
            color="grey.600"
            marginBottom="space-2"
            name="information"
            size="icon-20"
          />
        </RevenueTooltip>
      </HStack>
    </HStack>
  );
};

export default RevenueRow;
